
import React from 'react';

interface IconProps {
  size?: number;
}

const Html5Icon: React.FC<IconProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M1.623 0h20.754l-1.886 21.328-8.48 2.672-8.502-2.672L1.623 0zm17.97 4.144H6.407l.21 2.36h11.77l-.63 7.087-5.322 1.48v.002l-5.32-1.48-.358-4.01h2.36l.178 2.01 3.142.87v.002l3.14-.87.32-3.56H6.845l-.42-4.722h12.168l.21-2.36z" fill="#E34F26"/>
    </svg>
  );
};

export default Html5Icon;
